
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                ...(0, $9wGTI.fg)('confluence_forge_content_type_in_content_actions') ? {
                    type: (0, $hIaUw.getContentType)(routeName)
                } : {}
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("c4GFB"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("9eNzo"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("5FVRD"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("6f4WA"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("a1K4Q"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("fziMp"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("4KVi3"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("9HTJr"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("a7hf2"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6gWOx"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("8rogp"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("fscdi"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("c4GFB", function(module, exports) {

let $8ca6f5224fc3fedd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ca6f5224fc3fedd$var$load("2YffH"),
    $8ca6f5224fc3fedd$var$load("8Kivm"),
    $8ca6f5224fc3fedd$var$load("cf5vC"),
    $8ca6f5224fc3fedd$var$load("fyZ5h"),
    $8ca6f5224fc3fedd$var$load("bXhvu"),
    $8ca6f5224fc3fedd$var$load("iQ0Jm"),
    $8ca6f5224fc3fedd$var$load("coJiW"),
    $8ca6f5224fc3fedd$var$load("1iq83"),
    $8ca6f5224fc3fedd$var$load("6xnuw"),
    $8ca6f5224fc3fedd$var$load("h4Nf7"),
    $8ca6f5224fc3fedd$var$load("7f9Fz"),
    $8ca6f5224fc3fedd$var$load("fqGSw"),
    $8ca6f5224fc3fedd$var$load("6FuHS"),
    $8ca6f5224fc3fedd$var$load("eyaRC"),
    $8ca6f5224fc3fedd$var$load("49GA1"),
    $8ca6f5224fc3fedd$var$load("32K9i"),
    $8ca6f5224fc3fedd$var$load("aeEUI"),
    $8ca6f5224fc3fedd$var$load("iXzmH"),
    $8ca6f5224fc3fedd$var$load("65c4i"),
    $8ca6f5224fc3fedd$var$load("6wr18"),
    $8ca6f5224fc3fedd$var$load("kjZZD"),
    $8ca6f5224fc3fedd$var$load("3TTZL"),
    $8ca6f5224fc3fedd$var$load("37ldp"),
    $8ca6f5224fc3fedd$var$load("awqCy"),
    $8ca6f5224fc3fedd$var$load("kHOMt"),
    $8ca6f5224fc3fedd$var$load("hhss7"),
    $8ca6f5224fc3fedd$var$load("Wowvf"),
    $8ca6f5224fc3fedd$var$load("5465r"),
    $8ca6f5224fc3fedd$var$load("fkY2m"),
    $8ca6f5224fc3fedd$var$load("let0D"),
    $8ca6f5224fc3fedd$var$load("48JGY"),
    $8ca6f5224fc3fedd$var$load("63MsJ"),
    $8ca6f5224fc3fedd$var$load("7i8YW"),
    $8ca6f5224fc3fedd$var$load("ffEVr"),
    $8ca6f5224fc3fedd$var$load("55VuM"),
    $8ca6f5224fc3fedd$var$load("9ftJe"),
    $8ca6f5224fc3fedd$var$load("hUIij"),
    $8ca6f5224fc3fedd$var$load("6Up0b"),
    $8ca6f5224fc3fedd$var$load("lnKog"),
    $8ca6f5224fc3fedd$var$load("7EorR"),
    $8ca6f5224fc3fedd$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("9eNzo", function(module, exports) {

let $6b9bdf6cc4519756$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b9bdf6cc4519756$var$load("2YffH"),
    $6b9bdf6cc4519756$var$load("8Kivm"),
    $6b9bdf6cc4519756$var$load("cf5vC"),
    $6b9bdf6cc4519756$var$load("fyZ5h"),
    $6b9bdf6cc4519756$var$load("bXhvu"),
    $6b9bdf6cc4519756$var$load("iQ0Jm"),
    $6b9bdf6cc4519756$var$load("coJiW"),
    $6b9bdf6cc4519756$var$load("1iq83"),
    $6b9bdf6cc4519756$var$load("6xnuw"),
    $6b9bdf6cc4519756$var$load("h4Nf7"),
    $6b9bdf6cc4519756$var$load("7f9Fz"),
    $6b9bdf6cc4519756$var$load("fqGSw"),
    $6b9bdf6cc4519756$var$load("6FuHS"),
    $6b9bdf6cc4519756$var$load("eyaRC"),
    $6b9bdf6cc4519756$var$load("49GA1"),
    $6b9bdf6cc4519756$var$load("32K9i"),
    $6b9bdf6cc4519756$var$load("aeEUI"),
    $6b9bdf6cc4519756$var$load("iXzmH"),
    $6b9bdf6cc4519756$var$load("65c4i"),
    $6b9bdf6cc4519756$var$load("6wr18"),
    $6b9bdf6cc4519756$var$load("kjZZD"),
    $6b9bdf6cc4519756$var$load("3TTZL"),
    $6b9bdf6cc4519756$var$load("37ldp"),
    $6b9bdf6cc4519756$var$load("awqCy"),
    $6b9bdf6cc4519756$var$load("kHOMt"),
    $6b9bdf6cc4519756$var$load("hhss7"),
    $6b9bdf6cc4519756$var$load("Wowvf"),
    $6b9bdf6cc4519756$var$load("5465r"),
    $6b9bdf6cc4519756$var$load("fkY2m"),
    $6b9bdf6cc4519756$var$load("let0D"),
    $6b9bdf6cc4519756$var$load("48JGY"),
    $6b9bdf6cc4519756$var$load("63MsJ"),
    $6b9bdf6cc4519756$var$load("7i8YW"),
    $6b9bdf6cc4519756$var$load("ffEVr"),
    $6b9bdf6cc4519756$var$load("55VuM"),
    $6b9bdf6cc4519756$var$load("9ftJe"),
    $6b9bdf6cc4519756$var$load("hUIij"),
    $6b9bdf6cc4519756$var$load("6Up0b"),
    $6b9bdf6cc4519756$var$load("lnKog"),
    $6b9bdf6cc4519756$var$load("7EorR"),
    $6b9bdf6cc4519756$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("5FVRD", function(module, exports) {

let $421daaad14e36ac1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $421daaad14e36ac1$var$load("2YffH"),
    $421daaad14e36ac1$var$load("8Kivm"),
    $421daaad14e36ac1$var$load("cf5vC"),
    $421daaad14e36ac1$var$load("fyZ5h"),
    $421daaad14e36ac1$var$load("bXhvu"),
    $421daaad14e36ac1$var$load("iQ0Jm"),
    $421daaad14e36ac1$var$load("coJiW"),
    $421daaad14e36ac1$var$load("1iq83"),
    $421daaad14e36ac1$var$load("6xnuw"),
    $421daaad14e36ac1$var$load("h4Nf7"),
    $421daaad14e36ac1$var$load("7f9Fz"),
    $421daaad14e36ac1$var$load("fqGSw"),
    $421daaad14e36ac1$var$load("6FuHS"),
    $421daaad14e36ac1$var$load("eyaRC"),
    $421daaad14e36ac1$var$load("49GA1"),
    $421daaad14e36ac1$var$load("32K9i"),
    $421daaad14e36ac1$var$load("aeEUI"),
    $421daaad14e36ac1$var$load("iXzmH"),
    $421daaad14e36ac1$var$load("65c4i"),
    $421daaad14e36ac1$var$load("6wr18"),
    $421daaad14e36ac1$var$load("kjZZD"),
    $421daaad14e36ac1$var$load("3TTZL"),
    $421daaad14e36ac1$var$load("37ldp"),
    $421daaad14e36ac1$var$load("awqCy"),
    $421daaad14e36ac1$var$load("kHOMt"),
    $421daaad14e36ac1$var$load("hhss7"),
    $421daaad14e36ac1$var$load("Wowvf"),
    $421daaad14e36ac1$var$load("5465r"),
    $421daaad14e36ac1$var$load("fkY2m"),
    $421daaad14e36ac1$var$load("let0D"),
    $421daaad14e36ac1$var$load("48JGY"),
    $421daaad14e36ac1$var$load("63MsJ"),
    $421daaad14e36ac1$var$load("7i8YW"),
    $421daaad14e36ac1$var$load("ffEVr"),
    $421daaad14e36ac1$var$load("55VuM"),
    $421daaad14e36ac1$var$load("9ftJe"),
    $421daaad14e36ac1$var$load("hUIij"),
    $421daaad14e36ac1$var$load("6Up0b"),
    $421daaad14e36ac1$var$load("lnKog"),
    $421daaad14e36ac1$var$load("7EorR"),
    $421daaad14e36ac1$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("6f4WA", function(module, exports) {

let $48b7fa91e9638346$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $48b7fa91e9638346$var$load("6FuHS"),
    $48b7fa91e9638346$var$load("eyaRC"),
    $48b7fa91e9638346$var$load("2YffH"),
    $48b7fa91e9638346$var$load("cf5vC"),
    $48b7fa91e9638346$var$load("fyZ5h"),
    $48b7fa91e9638346$var$load("bXhvu"),
    $48b7fa91e9638346$var$load("1iq83"),
    $48b7fa91e9638346$var$load("6xnuw"),
    $48b7fa91e9638346$var$load("h4Nf7"),
    $48b7fa91e9638346$var$load("7f9Fz"),
    $48b7fa91e9638346$var$load("fqGSw"),
    $48b7fa91e9638346$var$load("49GA1"),
    $48b7fa91e9638346$var$load("32K9i"),
    $48b7fa91e9638346$var$load("aeEUI"),
    $48b7fa91e9638346$var$load("iXzmH"),
    $48b7fa91e9638346$var$load("65c4i"),
    $48b7fa91e9638346$var$load("6wr18"),
    $48b7fa91e9638346$var$load("kjZZD"),
    $48b7fa91e9638346$var$load("3TTZL"),
    $48b7fa91e9638346$var$load("37ldp"),
    $48b7fa91e9638346$var$load("awqCy"),
    $48b7fa91e9638346$var$load("kHOMt"),
    $48b7fa91e9638346$var$load("hhss7"),
    $48b7fa91e9638346$var$load("Wowvf"),
    $48b7fa91e9638346$var$load("5465r"),
    $48b7fa91e9638346$var$load("fkY2m"),
    $48b7fa91e9638346$var$load("let0D"),
    $48b7fa91e9638346$var$load("48JGY"),
    $48b7fa91e9638346$var$load("63MsJ"),
    $48b7fa91e9638346$var$load("7i8YW"),
    $48b7fa91e9638346$var$load("hUIij"),
    $48b7fa91e9638346$var$load("ffEVr"),
    $48b7fa91e9638346$var$load("55VuM"),
    $48b7fa91e9638346$var$load("9ftJe"),
    $48b7fa91e9638346$var$load("7EorR"),
    $48b7fa91e9638346$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("a1K4Q", function(module, exports) {

let $74cdbd52d2428015$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74cdbd52d2428015$var$load("6FuHS"),
    $74cdbd52d2428015$var$load("eyaRC"),
    $74cdbd52d2428015$var$load("2YffH"),
    $74cdbd52d2428015$var$load("cf5vC"),
    $74cdbd52d2428015$var$load("fyZ5h"),
    $74cdbd52d2428015$var$load("bXhvu"),
    $74cdbd52d2428015$var$load("1iq83"),
    $74cdbd52d2428015$var$load("6xnuw"),
    $74cdbd52d2428015$var$load("h4Nf7"),
    $74cdbd52d2428015$var$load("7f9Fz"),
    $74cdbd52d2428015$var$load("fqGSw"),
    $74cdbd52d2428015$var$load("49GA1"),
    $74cdbd52d2428015$var$load("32K9i"),
    $74cdbd52d2428015$var$load("aeEUI"),
    $74cdbd52d2428015$var$load("iXzmH"),
    $74cdbd52d2428015$var$load("65c4i"),
    $74cdbd52d2428015$var$load("6wr18"),
    $74cdbd52d2428015$var$load("kjZZD"),
    $74cdbd52d2428015$var$load("3TTZL"),
    $74cdbd52d2428015$var$load("37ldp"),
    $74cdbd52d2428015$var$load("awqCy"),
    $74cdbd52d2428015$var$load("kHOMt"),
    $74cdbd52d2428015$var$load("hhss7"),
    $74cdbd52d2428015$var$load("Wowvf"),
    $74cdbd52d2428015$var$load("5465r"),
    $74cdbd52d2428015$var$load("fkY2m"),
    $74cdbd52d2428015$var$load("let0D"),
    $74cdbd52d2428015$var$load("48JGY"),
    $74cdbd52d2428015$var$load("63MsJ"),
    $74cdbd52d2428015$var$load("7i8YW"),
    $74cdbd52d2428015$var$load("hUIij"),
    $74cdbd52d2428015$var$load("ffEVr"),
    $74cdbd52d2428015$var$load("55VuM"),
    $74cdbd52d2428015$var$load("9ftJe"),
    $74cdbd52d2428015$var$load("7EorR"),
    $74cdbd52d2428015$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("fziMp", function(module, exports) {

let $b558b12d3c02679f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b558b12d3c02679f$var$load("6FuHS"),
    $b558b12d3c02679f$var$load("eyaRC"),
    $b558b12d3c02679f$var$load("2YffH"),
    $b558b12d3c02679f$var$load("cf5vC"),
    $b558b12d3c02679f$var$load("fyZ5h"),
    $b558b12d3c02679f$var$load("bXhvu"),
    $b558b12d3c02679f$var$load("1iq83"),
    $b558b12d3c02679f$var$load("6xnuw"),
    $b558b12d3c02679f$var$load("h4Nf7"),
    $b558b12d3c02679f$var$load("7f9Fz"),
    $b558b12d3c02679f$var$load("fqGSw"),
    $b558b12d3c02679f$var$load("49GA1"),
    $b558b12d3c02679f$var$load("32K9i"),
    $b558b12d3c02679f$var$load("aeEUI"),
    $b558b12d3c02679f$var$load("iXzmH"),
    $b558b12d3c02679f$var$load("65c4i"),
    $b558b12d3c02679f$var$load("6wr18"),
    $b558b12d3c02679f$var$load("kjZZD"),
    $b558b12d3c02679f$var$load("3TTZL"),
    $b558b12d3c02679f$var$load("37ldp"),
    $b558b12d3c02679f$var$load("awqCy"),
    $b558b12d3c02679f$var$load("kHOMt"),
    $b558b12d3c02679f$var$load("hhss7"),
    $b558b12d3c02679f$var$load("Wowvf"),
    $b558b12d3c02679f$var$load("5465r"),
    $b558b12d3c02679f$var$load("fkY2m"),
    $b558b12d3c02679f$var$load("let0D"),
    $b558b12d3c02679f$var$load("48JGY"),
    $b558b12d3c02679f$var$load("63MsJ"),
    $b558b12d3c02679f$var$load("7i8YW"),
    $b558b12d3c02679f$var$load("hUIij"),
    $b558b12d3c02679f$var$load("ffEVr"),
    $b558b12d3c02679f$var$load("55VuM"),
    $b558b12d3c02679f$var$load("9ftJe"),
    $b558b12d3c02679f$var$load("7EorR"),
    $b558b12d3c02679f$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("4KVi3", function(module, exports) {

let $3767e5efc5bbba33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3767e5efc5bbba33$var$load("6FuHS"),
    $3767e5efc5bbba33$var$load("eyaRC"),
    $3767e5efc5bbba33$var$load("2YffH"),
    $3767e5efc5bbba33$var$load("cf5vC"),
    $3767e5efc5bbba33$var$load("fyZ5h"),
    $3767e5efc5bbba33$var$load("bXhvu"),
    $3767e5efc5bbba33$var$load("1iq83"),
    $3767e5efc5bbba33$var$load("6xnuw"),
    $3767e5efc5bbba33$var$load("h4Nf7"),
    $3767e5efc5bbba33$var$load("7f9Fz"),
    $3767e5efc5bbba33$var$load("fqGSw"),
    $3767e5efc5bbba33$var$load("49GA1"),
    $3767e5efc5bbba33$var$load("32K9i"),
    $3767e5efc5bbba33$var$load("aeEUI"),
    $3767e5efc5bbba33$var$load("iXzmH"),
    $3767e5efc5bbba33$var$load("65c4i"),
    $3767e5efc5bbba33$var$load("6wr18"),
    $3767e5efc5bbba33$var$load("kjZZD"),
    $3767e5efc5bbba33$var$load("3TTZL"),
    $3767e5efc5bbba33$var$load("37ldp"),
    $3767e5efc5bbba33$var$load("awqCy"),
    $3767e5efc5bbba33$var$load("kHOMt"),
    $3767e5efc5bbba33$var$load("hhss7"),
    $3767e5efc5bbba33$var$load("Wowvf"),
    $3767e5efc5bbba33$var$load("5465r"),
    $3767e5efc5bbba33$var$load("fkY2m"),
    $3767e5efc5bbba33$var$load("let0D"),
    $3767e5efc5bbba33$var$load("48JGY"),
    $3767e5efc5bbba33$var$load("63MsJ"),
    $3767e5efc5bbba33$var$load("7i8YW"),
    $3767e5efc5bbba33$var$load("ffEVr"),
    $3767e5efc5bbba33$var$load("55VuM"),
    $3767e5efc5bbba33$var$load("9ftJe"),
    $3767e5efc5bbba33$var$load("hUIij"),
    $3767e5efc5bbba33$var$load("6Up0b"),
    $3767e5efc5bbba33$var$load("lnKog"),
    $3767e5efc5bbba33$var$load("7EorR"),
    $3767e5efc5bbba33$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("9HTJr", function(module, exports) {

let $71135c643fe95328$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $71135c643fe95328$var$load("2YffH"),
    $71135c643fe95328$var$load("cf5vC"),
    $71135c643fe95328$var$load("fyZ5h"),
    $71135c643fe95328$var$load("bXhvu"),
    $71135c643fe95328$var$load("coJiW"),
    $71135c643fe95328$var$load("1iq83"),
    $71135c643fe95328$var$load("6xnuw"),
    $71135c643fe95328$var$load("h4Nf7"),
    $71135c643fe95328$var$load("7f9Fz"),
    $71135c643fe95328$var$load("fqGSw"),
    $71135c643fe95328$var$load("6FuHS"),
    $71135c643fe95328$var$load("eyaRC"),
    $71135c643fe95328$var$load("49GA1"),
    $71135c643fe95328$var$load("32K9i"),
    $71135c643fe95328$var$load("aeEUI"),
    $71135c643fe95328$var$load("iXzmH"),
    $71135c643fe95328$var$load("65c4i"),
    $71135c643fe95328$var$load("6wr18"),
    $71135c643fe95328$var$load("kjZZD"),
    $71135c643fe95328$var$load("3TTZL"),
    $71135c643fe95328$var$load("37ldp"),
    $71135c643fe95328$var$load("dTsOE"),
    $71135c643fe95328$var$load("awqCy"),
    $71135c643fe95328$var$load("kHOMt"),
    $71135c643fe95328$var$load("hhss7"),
    $71135c643fe95328$var$load("Wowvf"),
    $71135c643fe95328$var$load("5465r"),
    $71135c643fe95328$var$load("fkY2m"),
    $71135c643fe95328$var$load("let0D"),
    $71135c643fe95328$var$load("48JGY"),
    $71135c643fe95328$var$load("63MsJ"),
    $71135c643fe95328$var$load("7i8YW"),
    $71135c643fe95328$var$load("ffEVr"),
    $71135c643fe95328$var$load("55VuM"),
    $71135c643fe95328$var$load("9ftJe"),
    $71135c643fe95328$var$load("hUIij"),
    $71135c643fe95328$var$load("6Up0b"),
    $71135c643fe95328$var$load("lnKog"),
    $71135c643fe95328$var$load("7EorR"),
    $71135c643fe95328$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("a7hf2", function(module, exports) {

let $75d7eea615207267$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $75d7eea615207267$var$load("2YffH"),
    $75d7eea615207267$var$load("cf5vC"),
    $75d7eea615207267$var$load("fyZ5h"),
    $75d7eea615207267$var$load("bXhvu"),
    $75d7eea615207267$var$load("coJiW"),
    $75d7eea615207267$var$load("1iq83"),
    $75d7eea615207267$var$load("6xnuw"),
    $75d7eea615207267$var$load("h4Nf7"),
    $75d7eea615207267$var$load("7f9Fz"),
    $75d7eea615207267$var$load("fqGSw"),
    $75d7eea615207267$var$load("6FuHS"),
    $75d7eea615207267$var$load("eyaRC"),
    $75d7eea615207267$var$load("49GA1"),
    $75d7eea615207267$var$load("32K9i"),
    $75d7eea615207267$var$load("aeEUI"),
    $75d7eea615207267$var$load("iXzmH"),
    $75d7eea615207267$var$load("65c4i"),
    $75d7eea615207267$var$load("6wr18"),
    $75d7eea615207267$var$load("kjZZD"),
    $75d7eea615207267$var$load("3TTZL"),
    $75d7eea615207267$var$load("37ldp"),
    $75d7eea615207267$var$load("dTsOE"),
    $75d7eea615207267$var$load("awqCy"),
    $75d7eea615207267$var$load("kHOMt"),
    $75d7eea615207267$var$load("hhss7"),
    $75d7eea615207267$var$load("Wowvf"),
    $75d7eea615207267$var$load("5465r"),
    $75d7eea615207267$var$load("fkY2m"),
    $75d7eea615207267$var$load("let0D"),
    $75d7eea615207267$var$load("48JGY"),
    $75d7eea615207267$var$load("63MsJ"),
    $75d7eea615207267$var$load("7i8YW"),
    $75d7eea615207267$var$load("ffEVr"),
    $75d7eea615207267$var$load("55VuM"),
    $75d7eea615207267$var$load("9ftJe"),
    $75d7eea615207267$var$load("hUIij"),
    $75d7eea615207267$var$load("6Up0b"),
    $75d7eea615207267$var$load("lnKog"),
    $75d7eea615207267$var$load("7EorR"),
    $75d7eea615207267$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6gWOx", function(module, exports) {

let $4911dbf0e7218d04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4911dbf0e7218d04$var$load("6FuHS"),
    $4911dbf0e7218d04$var$load("eyaRC"),
    $4911dbf0e7218d04$var$load("2YffH"),
    $4911dbf0e7218d04$var$load("cf5vC"),
    $4911dbf0e7218d04$var$load("fyZ5h"),
    $4911dbf0e7218d04$var$load("bXhvu"),
    $4911dbf0e7218d04$var$load("1iq83"),
    $4911dbf0e7218d04$var$load("6xnuw"),
    $4911dbf0e7218d04$var$load("h4Nf7"),
    $4911dbf0e7218d04$var$load("7f9Fz"),
    $4911dbf0e7218d04$var$load("fqGSw"),
    $4911dbf0e7218d04$var$load("49GA1"),
    $4911dbf0e7218d04$var$load("32K9i"),
    $4911dbf0e7218d04$var$load("aeEUI"),
    $4911dbf0e7218d04$var$load("iXzmH"),
    $4911dbf0e7218d04$var$load("65c4i"),
    $4911dbf0e7218d04$var$load("6wr18"),
    $4911dbf0e7218d04$var$load("kjZZD"),
    $4911dbf0e7218d04$var$load("3TTZL"),
    $4911dbf0e7218d04$var$load("37ldp"),
    $4911dbf0e7218d04$var$load("awqCy"),
    $4911dbf0e7218d04$var$load("kHOMt"),
    $4911dbf0e7218d04$var$load("hhss7"),
    $4911dbf0e7218d04$var$load("Wowvf"),
    $4911dbf0e7218d04$var$load("5465r"),
    $4911dbf0e7218d04$var$load("fkY2m"),
    $4911dbf0e7218d04$var$load("let0D"),
    $4911dbf0e7218d04$var$load("48JGY"),
    $4911dbf0e7218d04$var$load("63MsJ"),
    $4911dbf0e7218d04$var$load("7i8YW"),
    $4911dbf0e7218d04$var$load("hUIij"),
    $4911dbf0e7218d04$var$load("ffEVr"),
    $4911dbf0e7218d04$var$load("55VuM"),
    $4911dbf0e7218d04$var$load("9ftJe"),
    $4911dbf0e7218d04$var$load("7EorR"),
    $4911dbf0e7218d04$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("8rogp", function(module, exports) {

let $6253aa978b1f07cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6253aa978b1f07cc$var$load("6FuHS"),
    $6253aa978b1f07cc$var$load("eyaRC"),
    $6253aa978b1f07cc$var$load("2YffH"),
    $6253aa978b1f07cc$var$load("cf5vC"),
    $6253aa978b1f07cc$var$load("fyZ5h"),
    $6253aa978b1f07cc$var$load("bXhvu"),
    $6253aa978b1f07cc$var$load("1iq83"),
    $6253aa978b1f07cc$var$load("6xnuw"),
    $6253aa978b1f07cc$var$load("h4Nf7"),
    $6253aa978b1f07cc$var$load("7f9Fz"),
    $6253aa978b1f07cc$var$load("fqGSw"),
    $6253aa978b1f07cc$var$load("49GA1"),
    $6253aa978b1f07cc$var$load("32K9i"),
    $6253aa978b1f07cc$var$load("aeEUI"),
    $6253aa978b1f07cc$var$load("iXzmH"),
    $6253aa978b1f07cc$var$load("65c4i"),
    $6253aa978b1f07cc$var$load("6wr18"),
    $6253aa978b1f07cc$var$load("kjZZD"),
    $6253aa978b1f07cc$var$load("3TTZL"),
    $6253aa978b1f07cc$var$load("37ldp"),
    $6253aa978b1f07cc$var$load("awqCy"),
    $6253aa978b1f07cc$var$load("kHOMt"),
    $6253aa978b1f07cc$var$load("hhss7"),
    $6253aa978b1f07cc$var$load("Wowvf"),
    $6253aa978b1f07cc$var$load("5465r"),
    $6253aa978b1f07cc$var$load("fkY2m"),
    $6253aa978b1f07cc$var$load("let0D"),
    $6253aa978b1f07cc$var$load("48JGY"),
    $6253aa978b1f07cc$var$load("63MsJ"),
    $6253aa978b1f07cc$var$load("7i8YW"),
    $6253aa978b1f07cc$var$load("ffEVr"),
    $6253aa978b1f07cc$var$load("55VuM"),
    $6253aa978b1f07cc$var$load("9ftJe"),
    $6253aa978b1f07cc$var$load("hUIij"),
    $6253aa978b1f07cc$var$load("6Up0b"),
    $6253aa978b1f07cc$var$load("lnKog"),
    $6253aa978b1f07cc$var$load("7EorR"),
    $6253aa978b1f07cc$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("fscdi", function(module, exports) {

let $b402f1de2992e23d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b402f1de2992e23d$var$load("6FuHS"),
    $b402f1de2992e23d$var$load("eyaRC"),
    $b402f1de2992e23d$var$load("2YffH"),
    $b402f1de2992e23d$var$load("cf5vC"),
    $b402f1de2992e23d$var$load("fyZ5h"),
    $b402f1de2992e23d$var$load("bXhvu"),
    $b402f1de2992e23d$var$load("1iq83"),
    $b402f1de2992e23d$var$load("6xnuw"),
    $b402f1de2992e23d$var$load("h4Nf7"),
    $b402f1de2992e23d$var$load("7f9Fz"),
    $b402f1de2992e23d$var$load("fqGSw"),
    $b402f1de2992e23d$var$load("49GA1"),
    $b402f1de2992e23d$var$load("32K9i"),
    $b402f1de2992e23d$var$load("aeEUI"),
    $b402f1de2992e23d$var$load("iXzmH"),
    $b402f1de2992e23d$var$load("65c4i"),
    $b402f1de2992e23d$var$load("6wr18"),
    $b402f1de2992e23d$var$load("kjZZD"),
    $b402f1de2992e23d$var$load("3TTZL"),
    $b402f1de2992e23d$var$load("37ldp"),
    $b402f1de2992e23d$var$load("awqCy"),
    $b402f1de2992e23d$var$load("kHOMt"),
    $b402f1de2992e23d$var$load("hhss7"),
    $b402f1de2992e23d$var$load("Wowvf"),
    $b402f1de2992e23d$var$load("5465r"),
    $b402f1de2992e23d$var$load("fkY2m"),
    $b402f1de2992e23d$var$load("let0D"),
    $b402f1de2992e23d$var$load("48JGY"),
    $b402f1de2992e23d$var$load("63MsJ"),
    $b402f1de2992e23d$var$load("7i8YW"),
    $b402f1de2992e23d$var$load("ffEVr"),
    $b402f1de2992e23d$var$load("55VuM"),
    $b402f1de2992e23d$var$load("9ftJe"),
    $b402f1de2992e23d$var$load("hUIij"),
    $b402f1de2992e23d$var$load("6Up0b"),
    $b402f1de2992e23d$var$load("lnKog"),
    $b402f1de2992e23d$var$load("7EorR"),
    $b402f1de2992e23d$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.c43b3497.js.map
